export default "__VITE_ASSET__BJnz9rFI__"